// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { OfferAndPoolingAreaId } from './OfferAndPoolingAreaId'
import {
  OfferAndPoolingAreaNavigation,
  OfferAndPoolingAreaNavigationIcon,
} from './OfferAndPoolingAreaNavigation'
import { OfferAndPoolingAreaRoutes } from './OfferAndPoolingAreaRoutes'

const LazyOfferAndPoolingComponent = lazy(() => import('./OfferAndPoolingArea'))

const OfferAndPoolingComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyOfferAndPoolingComponent />
  </SuspenseLoadingWrapper>
)

export const OfferAndPoolingArea = {
  id: OfferAndPoolingAreaId,
  requiredRight: BoumRight.AREA_OFFER_AND_POOLING,
  Icon: OfferAndPoolingAreaNavigationIcon,
  NavigationComponent: OfferAndPoolingAreaNavigation,
  route: {
    path: OfferAndPoolingAreaRoutes.route,
    component: OfferAndPoolingComponent,
  },
}
